<template>
<div>
    <base-card overflowVisible :title="$t('documentsAndInformation')" v-if="files" :hideButtons="historyReadOnly">
        <div class="row">
            <div class="col-lg-7 col-12 p-1">
                <base-select searchable :loading="tagSelect.loading" :options="tagSelect.options" v-model="tagSelect.value" @change="tagSelected" :label="$i18nHelpers.normalizeProp('name')" valueProp="id" :placeholder="$t('addfile-ph')" clearable></base-select>
            </div>
            <div v-if="showDocumentOrLinkSelector" class="col-lg-7 col-12 p-1">
                <base-radio-group :options="documentOrLinkOptions" @change="documentOrLinkSelected" v-model="documentOrLinkValue"></base-radio-group>
            </div>
            <div v-if="showUploadLinkBox" class="col-12 p-1">
                <div class="row">
                    <base-input zeroMarginBottom class="col-12 col-md-5 pr-md-2 margin-bottom-reduced" :placeholder="$t('name')" v-model="link.name"></base-input>
                    <base-input zeroMarginBottom class="col-12 col-md-5 pr-md-2 margin-bottom-reduced" :placeholder="$t('document.url')" v-model="link.url"></base-input>
                    <div class="col-md-2">
                        <base-button @click="saveLink">{{ $t('save-btn') }}</base-button>
                    </div>
                </div>
            </div>
            <b-form-file class="col-lg-7 col-12 mt-2"
            v-model="uploader.file"
            :placeholder="$t('select-or-drag-drop-file')"
            :drop-placeholder="$t('drag-drop-file')"
            :browse-text="$t('browse')"
            @input="uploadFile" v-if="showUploadBox"
            ></b-form-file>
        </div>
        <div class="col-lg-7 col-12 p-1 mb-4">
            <base-select :loading="tagSelect.loading" :options="tagSelect.options" v-model="tagSelect.filter" :label="$i18nHelpers.normalizeProp('name')" valueProp="id" :placeholder="$t('filterByType')" clearable></base-select>
        </div>
        <paginated-table :fields="table.fields" :items="files" :empty-text="$t('nofiles')" :filter="tagSelect.filter ? `${tagSelect.filter}` : null" :filterFn="filterTableCategories" :stacked="stacked">
            <template v-slot:cell(viewLink)="data">
                <span class="table-href" v-if="data.item.link && !fileLocked(data)" @click.prevent="accessLink(data.item.link, data.item.idHisEnlaces)">{{ $t('watch') }}</span>
            </template>
            <template v-slot:cell(complete)="data" v-if="!historyReadOnly">
                <a href="#" v-if="showCompleteLink(data.item)" @click.prevent="completeAction(data.item)">{{ $t('complete') }}</a>
                <span class="completed-title" v-if="showCompletedTitle(data.item) && !fileLocked(data)" v-text="$t('completedHistory')"></span>
            </template>
            <template v-slot:cell(preview)="data" v-if="!historyReadOnly">
                <span class="table-href" v-if="!data.item.idHisEnlaces && !fileLocked(data) && !data.item.readOnly" @click.prevent="getFiles(data.item.fileId)">{{ $t('download-btn') }}</span>
            </template>
            <template v-slot:cell(lockStatus)="data" v-if="!historyReadOnly">
                <b-icon-lock-fill v-if="$store.getters['session/userIsPatient'] && data.item.locked" @click="modifyFileLocking(true, data.item)" class="icon-locked"></b-icon-lock-fill>
                <b-icon-unlock-fill v-else-if="$store.getters['session/userIsPatient'] && !data.item.locked" @click="modifyFileLocking(false, data.item)" class="icon-unlocked"></b-icon-unlock-fill>
                <b-icon-lock-fill v-if="!$store.getters['session/userIsPatient'] && fileLocked(data)" @click="showLockedMessage" class="icon-locked"></b-icon-lock-fill>
            </template>
            <template v-slot:cell(remove)="data" v-if="!historyReadOnly">
                <base-icon class="clickable" v-if="!fileLocked(data) && data.item.fileType != PRESCRIPTION_TYPE && data.item.fileType != REPORT_TYPE" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg" @click.prevent="remove(data.item)" :color="RED_COLOUR"></base-icon>
            </template>
            <template #cell(actionsMobile)="data" v-if="!historyReadOnly">
                <div v-if="fileLocked(data)">
                    <span v-html="$t('fileLockedByPatient')"></span>
                </div>
                <div v-else>
                    <div class="stacked-item" v-if="data.item.link">
                        <span class="table-href" @click.prevent="accessLink(data.item.link, data.item.idHisEnlaces)"><b-icon-eye class="blue"></b-icon-eye></span>
                    </div>
                    <div class="stacked-item" v-if="showCompleteLink(data.item) || showCompletedTitle(data.item)">
                        <a href="#" v-if="showCompleteLink(data.item)" @click.prevent="completeAction(data.item)"><b-icon-pencil class="blue"></b-icon-pencil></a>
                        <span class="completed-title" v-if="showCompletedTitle(data.item)"><b-icon-check class="blue"></b-icon-check></span>
                    </div>
                    <div class="stacked-item" v-if="!data.item.idHisEnlaces && !data.item.readOnly">
                        <span class="table-href" @click.prevent="getFiles(data.item.fileId)"><b-icon-download class="blue"></b-icon-download></span>
                    </div>
                    <div class="stacked-item" v-if="$store.getters['session/userIsPatient']">
                        <span v-if="data.item.locked"><b-icon-lock-fill @click="modifyFileLocking(true, data.item)" class="icon-locked"></b-icon-lock-fill></span>
                        <span v-else-if="!data.item.locked"><b-icon-unlock-fill @click="modifyFileLocking(false, data.item)" class="icon-unlocked"></b-icon-unlock-fill></span>
                    </div>
                    <div class="stacked-item" v-if="data.item.fileType != PRESCRIPTION_TYPE && data.item.fileType != REPORT_TYPE">
                        <base-icon class="clickable" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg" @click.prevent="remove(data.item)" :color="RED_COLOUR"></base-icon>
                    </div>
                    <hr>
                </div>
            </template>
        </paginated-table>
    </base-card>
    <base-modal v-model="showCompleteModal" @hidden="resetCompleteModal">
        <div class="text-center">
            <div v-if="selectedCompleteFile.idHisEnlaces">
                <p v-html="$t('mark-as-complete-text')"></p>
            </div>
            <div v-else>
                <p v-html="$t('history-files-overwrite-content')"></p>
                <b-form-file class="col-lg-7 col-12 mt-2 mb-4"
                v-model="uploaderOverwrite.file"
                :placeholder="$t('select-or-drag-drop-file')"
                :drop-placeholder="$t('drag-drop-file')"
                :browse-text="$t('browse')"
                ></b-form-file>
                <p v-html="$t('history-files-overwrite-question')"></p>
            </div>
            <div>
                <base-button class="mr-2" @click="completeFile">{{$t('yes')}}</base-button>
                <base-button red @click="resetCompleteModal">{{$t('no')}}</base-button>
            </div>
        </div>
    </base-modal>
    <base-dialog v-model="lockDialogInfo.show" :content="lockDialogInfo.locking ? $t('lock-file-advice') : $t('unlock-file-advice')" :okFn="() => { lockDialogInfo.locking ? lockFile() : unlockFile() }" :cancelFn="() => { lockDialogInfo.show = false }"></base-dialog>
</div>
</template>

<script>
import PaginatedTable from '@/components/base/PaginatedTable'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import FilesRepository from '@/repositories/FilesRepository'
import BaseSelect from '@/components/base/forms/BaseSelect'
import BaseButton from '@/components/base/buttons/BaseButton'
import AddButton from '@/components/base/buttons/AddButton'
import BaseCard from '@/components/base/ui/BaseCard.vue'
import filters from '@/plugins/filters'
import { RED_COLOUR } from '@/constants/colours'
import { isDocumentOrLink, isDocumentOrLinkPendingComplete, isDocumentOrLinkCompleted, RECOMMENDED_APPLICATIONS, USEFUL_LINK } from '@/constants/clinicHistory'
import { BIconEye, FormFilePlugin, BIconUpload, BIconFileEarmarkText, BFormFile } from 'bootstrap-vue'
import BaseModal from '../base/BaseModal.vue'
import BaseDialog from '../base/BaseDialog.vue'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import * as historyDataEs from '@/lang/es/clinic-history.json'
import * as historyDataEn from '@/lang/en/clinic-history.json'
import * as historyDataPt from '@/lang/pt/clinic-history.json'
import { EN_LOCALE, PT_LOCALE } from '@/constants/locales'
import { PRESCRIPTION_TYPE, REPORT_TYPE } from '@/constants/db/patientFiles'

export default {
    name: 'history-files-section',
    components: {
        PaginatedTable,
        BaseSelect,
        BaseButton,
        AddButton,
        BaseCard,
        BFormFile,
        BIconFileEarmarkText,
        BIconUpload,
        FormFilePlugin,
        BIconEye,
        BaseModal,
        BaseDialog
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [clinicHistoryMixin],
    computed: {
        stacked () {
            return window.innerWidth < 810
        },
        clinicHistoryRepository () {
            return ClinicHistoryRepository()
        }
    },
    data () {
        return {
            files: null,
            showUploadBox: false,
            lockDialogInfo: {
                id: null,
                show: false,
                locking: false
            },
            uploader: {
                file: null
            },
            uploaderOverwrite: {
                file: null
            },
            selectedCompleteFile: {
                id: null,
                idHisEnlaces: null
            },
            table: {
                fields: [
                    {
                        label: this.$t('name-column'),
                        key: 'fileName'
                    },
                    {
                        label: this.$t('file-type-column'),
                        key: 'category',
                        formatter: (value, key, item) => {
                            return !value ? this.$t('undefined') : this.$i18nHelpers.normalize(value)
                        }
                    },
                    {
                        label: this.$t('uploadedby-column'),
                        key: 'createdBy'
                    },
                    {
                        label: this.$t('date-column'),
                        key: 'createdAt',
                        formatter: (value, key, item) => {
                            return value ? filters.beautifySimpleDate(value) : '-'
                        },
                        sortable: true
                    },
                    {
                        label: '',
                        key: 'actionsMobile',
                        class: 'table-actions'
                    },
                    {
                        label: '',
                        key: 'viewLink',
                        hiddenStacked: true
                    },
                    {
                        label: '',
                        key: 'complete',
                        hiddenStacked: true
                    },
                    {
                        label: '',
                        key: 'preview',
                        hiddenStacked: true
                    },
                    {
                        label: '',
                        key: 'lockStatus',
                        hiddenStacked: true
                    },
                    {
                        label: '',
                        key: 'remove',
                        hiddenStacked: true
                    }
                ],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            tagSelect: {
                options: [],
                value: null,
                loading: false,
                filter: null
            },
            showCompleteModal: false,
            showDocumentOrLinkSelector: false,
            documentOrLinkValue: null,
            showUploadLinkBox: false,
            documentOrLinkOptions: [{text: this.$t('document.uploadFromThisDevice'), value: 0}, {text: this.$t('document.insertLink'), value: 1}],
            link: {
                name: null,
                url: null
            },
            RED_COLOUR,
            PRESCRIPTION_TYPE,
            REPORT_TYPE
        }
    },
    methods: {
        load () {
            this.loading = true
            this.clinicHistoryRepository.getHistoryFiles().then((response) => {
                this.files = response.data.data
                this.loading = false
            })
            if (this.tagSelect.options.length === 0) {
                FilesRepository.getFilesTags().then((response) => {
                    let tags = response.data.filter(item => item.id !== 13)
                    tags.push({id: -1, name: {es: historyDataEs.reportOrPrescripcion, en: historyDataEn.reportOrPrescripcion, pt: historyDataPt.reportOrPrescripcion}})
                    tags.push({id: -2, name: {es: historyDataEs.dataopensalud, en: historyDataEn.dataopensalud, pt: historyDataPt.dataopensalud}})
                    tags.sort((a, b) => this.$i18n.locale === EN_LOCALE ? a.name.en > b.name.en : this.$i18n.locale === PT_LOCALE ? a.name.pt > b.name.pt : a.name.es > b.name.es)
                    this.tagSelect.options = tags
                })
            }
        },
        loadApps () {
            this.clinicHistoryRepository.getApps().then((response) => {
                this.files = response.data.data
                this.loading = false
            })
            if (this.tagSelect.options.length === 0) {
                FilesRepository.getFilesTags(true).then((response) => {
                    this.tagSelect.options = response.data
                })
            }
        },
        fileLocked (data) {
            return data && data.item && data.item.locked && !this.$store.getters['session/userIsPatient']
        },
        showLockedMessage () {
            this.$store.dispatch('showInfoAlert', this.$t('fileLockedByPatient'))
        },
        showCompleteLink (data) {
            return data.idHisEnlaces ? isDocumentOrLinkPendingComplete(data.categoryId) : isDocumentOrLink(data.categoryId)
        },
        showCompletedTitle (data) {
            return data.idHisEnlaces && isDocumentOrLinkCompleted(data.categoryId)
        },
        getFiles (fileId) {
					let windowReference = window.open()
					this.clinicHistoryRepository.getFiles(fileId).then((response) => {
						windowReference.location = response.data
						this.$store.dispatch('notifications/updateSummary')
					})
        },
        documentOrLinkSelected () {
            if (this.documentOrLinkValue === 0) {
                this.showUploadLinkBox = false
                this.showUploadBox = true
            } else if (this.documentOrLinkValue === 1) {
                this.showUploadBox = false
                this.showUploadLinkBox = true
            }
        },
        tagSelected () {
            if (this.tagSelect.value) {
                this.documentOrLinkValue = null
                this.showUploadLinkBox = false
                if (this.tagSelect.value === RECOMMENDED_APPLICATIONS || this.tagSelect.value === USEFUL_LINK) {
                    this.showUploadLinkBox = true
                    this.showUploadBox = false
                } else if (isDocumentOrLink(this.tagSelect.value) && !this.documentOrLinkValue) {
                    this.showUploadBox = false
                    this.showDocumentOrLinkSelector = true
                } else {
                    this.showUploadBox = true
                    this.showDocumentOrLinkSelector = false
                }
            } else {
                this.tagSelect.value = null
                this.link.name = null
                this.link.url = null
                this.documentOrLinkValue = null
                this.showUploadBox = false
                this.showUploadLinkBox = false
                this.showDocumentOrLinkSelector = false
            }
        },
        filterTableCategories (data, filter) {
            return data.categoryId === parseInt(filter)
        },
        saveLink () {
            if (!this.link.name) {
                this.$store.dispatch('showInfoAlert', this.$t('link.nameError'))
            } else if (!this.link.url || !this.$validators.validateUrl(this.link.url)) {
                this.$store.dispatch('showInfoAlert', this.$t('link.linkError'))
            } else {
                let data = {fileCategory: this.tagSelect.value, link: this.link}
                this.clinicHistoryRepository.saveApps(data).then((response) => {
                this.load()
                this.resetFormFile()
            })
            }
        },
        uploadFile (file) {
            if (!file) return
            const _this = this
            this.clinicHistoryRepository.uploadFileToClinicHistory(file, this.tagSelect.value, this).then((response) => {
                _this.load()
                _this.resetFormFile()
            })
        },
        resetFormFile () {
            this.tagSelect.value = null
            this.uploader.file = null
            this.uploaderOverwrite.file = null
            this.link.name = null
            this.link.url = null
            this.documentOrLinkValue = null
            this.showUploadBox = false
            this.showUploadLinkBox = false
            this.showDocumentOrLinkSelector = false
            this.selectedCompleteFile.id = null
            this.selectedCompleteFile.idHisEnlaces = null
            this.showCompleteModal = false
        },
        accessLink (url, fileId) {
            FilesRepository.markLinkAsReaded(fileId)
            window.open(url.indexOf('http') > -1 ? url : `http://${url}`, '_blank')
        },
        resetCompleteModal () {
            this.showCompleteModal = false
            this.uploaderOverwrite.file = null
            this.resetFormFile()
        },
        completeAction (data) {
            this.showCompleteModal = true
            this.selectedCompleteFile.id = data.id
            this.selectedCompleteFile.idHisEnlaces = data.idHisEnlaces
        },
        completeFile () {
            if (this.selectedCompleteFile.idHisEnlaces) {
                this.clinicHistoryRepository.markFileAsCompleted({id: this.selectedCompleteFile.idHisEnlaces}).then((response) => {
                    this.load()
                    this.resetFormFile()
                })
            } else {
                if (!this.uploaderOverwrite.file) {
                    this.$store.dispatch('showInfoAlert', this.$t('file.select'))
                    return
                }
                this.clinicHistoryRepository.overwriteFileClinicHistory(this.uploaderOverwrite.file, this.selectedCompleteFile.id, this).then((response) => {
                    this.load()
                    this.resetFormFile()
                    this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                })
            }
        },
        modifyFileLocking (unlock, data) {
            this.lockDialogInfo.locking = !unlock
            this.lockDialogInfo.show = true
            this.lockDialogInfo.id = data.idHisEnlaces || data.id
        },
        lockFile () {
            this.clinicHistoryRepository.lockFile(this.lockDialogInfo.id).then(response => {
                this.lockChangeCompleted()
            })
        },
        unlockFile () {
            this.clinicHistoryRepository.unlockFile(this.lockDialogInfo.id).then(response => {
                this.lockChangeCompleted()
            })
        },
        lockChangeCompleted () {
            let file = this.files.find(f => f.id === this.lockDialogInfo.id || f.idHisEnlaces === this.lockDialogInfo.id)
            file.locked = !file.locked
            this.lockDialogInfo.show = false
            this.lockDialogInfo.id = null
        },
        remove (data) {
            if (data.idHisEnlaces) {
                this.clinicHistoryRepository.deleteApps(data.idHisEnlaces).then(response => {
                    if (response.data.data) {
                        this.files = this.files.filter(item => item.idHisEnlaces !== data.idHisEnlaces)
                    }
                })
            } else {
                this.clinicHistoryRepository.deleteHistoryFile(data.id).then(response => {
                    if (response.data.data) {
                        this.files = this.files.filter(item => item.id !== data.id)
                    }
                })
            }
        }
    },
    created () {
        this.load()
    }
}
</script>

<style lang="scss" scoped>
    .completed-title{
        color: $green;
    }
    .icon-unlocked{
        cursor: pointer;
        color: $green;
    }
    .icon-locked{
        cursor: pointer;
        color: $red;
    }
    .table-href{
        cursor: pointer;
        color: $blue;
        &:hover{
            text-decoration: underline;
        }
    }
    .blue{
        color: $blue;
    }
    .margin-bottom-reduced{
        margin-bottom: 0.5rem;
    }
    .stacked-item{
        display: inline-block;
        margin-right: 1rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryFilesSection.vue